import { motion } from "framer-motion"
import { Component } from "react"
import ReactDOM from "react-dom"

const LaunchAnimator = ({ rect, onDone, PreviewComponent }) => {
  const target = {
    top: 0,
    left: 0,
    width: window.innerWidth,
    height: window.innerHeight
  }

  return (
    <motion.div
      className="LaunchAnimator"
      children={PreviewComponent && <PreviewComponent />}
      initial={{
        x: 0,
        top: rect.top,
        left: rect.left,
        width: rect.width,
        height: rect.height,
        borderRadius: 20
      }}
      animate={{
        x: 1,
        top: target.top,
        left: target.left,
        width: target.width,
        height: target.height,
        borderRadius: 0
      }}
      transition={{ type: "spring", stiffness: 250, damping: 20 }}
      style={{
        zIndex: 999999999,
        position: "fixed",
        backgroundColor: !PreviewComponent && "whitesmoke",
        transform: "translateZ(0)",
        overflow: "hidden"
      }}
      onAnimationComplete={onDone}
    />
  )
}

const withLauncher = (options) => {
  // Allowing for options to be a component or set of components.
  const {
    Component: ComposedComponent,
    Preview: PreviewComponent,
    Preload: PreloadComponent
  } = options.Component
    ? options
    : {
        Component: options
      }

  return class Launcher extends Component {
    defaultState = {
      show: false,
      rect: null,
      to: null
    }

    state = { ...this.defaultState }

    componentDidMount() {
      this.mounted = true
    }

    componentWillUnmount() {
      this.mounted = false
    }

    handleLaunch = async (to) => {
      const rect = ReactDOM.findDOMNode(this).getBoundingClientRect()

      if (PreloadComponent && typeof PreloadComponent.preload === "function") {
        await PreloadComponent.preload()
      }

      this.setState({
        to,
        rect,
        show: true
      })
    }

    handleDone = (to) => {
      // FIXME: better way to do this

      if (window.App) window.App.navigate(to)
      if (typeof this.props.onLaunched === "function") this.props.onLaunched(to)
      if (this.mounted) this.setState(this.defaultState)
    }

    render() {
      return (
        <>
          <ComposedComponent {...this.props} onLaunch={this.handleLaunch} />
          {this.state.show
            ? ReactDOM.createPortal(
                <LaunchAnimator
                  rect={this.state.rect}
                  PreviewComponent={PreviewComponent}
                  onDone={() => this.handleDone(this.state.to)}
                />,
                document.body
              )
            : null}
        </>
      )
    }
  }
}

export default withLauncher
